import React, {useState} from 'react';
import FormInput from "../../../Components/Forms/FormInput";
import {
    BOOLEAN_OPTIONS, NATIONALITY_OPTIONS, PHONE_PREFIX_OPTIONS,
    TITLE_OPTIONS
} from "../../../constants";
import SecondaryTitle from "../../../Components/SecondaryTitle";

const BasicDetails = (props) => {
    const {
        data = {
            'title':                        '',
            'first_name':                   '',
            'last_name':                    '',
            'email':                        '',
            'phone_prefix':                 '',
            'phone_number':                 '',
            'dual_nationality':             0,
            'primary_nationality':          '',
            'secondary_nationality':        '',
            'date_of_birth':                '',
            'national_insurance_number':    '',
            'phone_password':               '',
            'occupation':                   '',
        },
        errors      = null,
        onChange    = (field, value) => {},
        disabled    = false,
        index
    } = props;

    return (
        <React.Fragment>
            <SecondaryTitle>Personal Details</SecondaryTitle>
            <div className={'row m-0 p-0'}>
                <div className={'col-12 col-sm-4 col-md-3 m-0 p-0 pe-sm-2'}>
                    <FormInput
                        required={true}
                        name={'title'}
                        detailedLabel={'Title'}
                        value={data.title}
                        type={'select'}
                        options={TITLE_OPTIONS}
                        onChange={(value) => onChange('title', value)}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
                <div className={'col-12 col-sm-4 col-md m-0 p-0 ps-sm-2 pe-sm-2'}>
                    <FormInput
                        required={true}
                        name={'first_name'}
                        detailedLabel={'First name'}
                        value={data.first_name}
                        type={'text'}
                        onChange={(value) => onChange('first_name', value)}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
                <div className={'col-12 col-sm-4 col-md m-0 p-0 ps-sm-2'}>
                    <FormInput
                        required={true}
                        name={'last_name'}
                        detailedLabel={'Last name'}
                        value={data.last_name}
                        type={'text'}
                        onChange={(value) => onChange('last_name', value)}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
            </div>
            <FormInput
                required={true}
                name={'email'}
                detailedLabel={'Email address'}
                value={data.email}
                type={'email'}
                onChange={(value) => onChange('email', value)}
                error={errors}
            />
            <FormInput
                required={true}
                name={'phone_password'}
                detailedLabel={'Password for telephone customer service'}
                value={data.phone_password}
                type={'password'}
                onChange={(value) => onChange('phone_password', value)}
                disabled={disabled}
                error={errors}
            />
            <div className={'row m-0 p-0'}>
                <div className={'col-12 col-sm-4 col-md-3 m-0 p-0 pe-sm-2'}>
                    <FormInput
                        required={true}
                        name={'phone_prefix'}
                        detailedLabel={'Phone prefix'}
                        value={data.phone_prefix}
                        type={'select'}
                        options={PHONE_PREFIX_OPTIONS}
                        onChange={(value) => onChange('phone_prefix', value)}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
                <div className={'col-12 col-sm-8 col-md-9 m-0 p-0 ps-sm-2'}>
                    <FormInput
                        required={true}
                        name={'phone_number'}
                        detailedLabel={'Phone number'}
                        value={data.phone_number}
                        type={'text'}
                        onChange={(value) => onChange('phone_number', value)}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
            </div>
            <FormInput
                required={true}
                name={'dual_nationality'}
                detailedLabel={'Dual nationality'}
                value={data.dual_nationality}
                type={'select'}
                options={BOOLEAN_OPTIONS}
                onChange={(value) => onChange('dual_nationality', value)}
                disabled={disabled}
                error={errors}
            />
            {data.dual_nationality === '1' ? (
                <div className={'row m-0 p-0'}>
                    <div className={'col-12 col-md-6 m-0 p-0 pe-md-2'}>
                        <FormInput
                            required={true}
                            name={'primary_nationality'}
                            detailedLabel={'Primary nationality'}
                            value={data.primary_nationality}
                            type={'select'}
                            options={NATIONALITY_OPTIONS}
                            onChange={(value) => onChange('primary_nationality', value)}
                            disabled={disabled}
                            error={errors}
                        />
                    </div>
                    <div className={'col-12 col-md-6 m-0 p-0 ps-md-2'}>
                        <FormInput
                            required={true}
                            name={'secondary_nationality'}
                            detailedLabel={'Secondary nationality'}
                            value={data.secondary_nationality}
                            type={'select'}
                            options={NATIONALITY_OPTIONS}
                            onChange={(value) => onChange('secondary_nationality', value)}
                            disabled={disabled}
                            error={errors}
                        />
                    </div>
                </div>
            ) : (
                <FormInput
                    required={true}
                    name={'primary_nationality'}
                    detailedLabel={'Nationality'}
                    value={data.primary_nationality}
                    type={'select'}
                    options={NATIONALITY_OPTIONS}
                    onChange={(value) => onChange('primary_nationality', value)}
                    disabled={disabled}
                    error={errors}
                />
            )}
            <div className={'row m-0 p-0'}>
                <div className={'col-12 col-md-6 m-0 p-0 pe-md-2'}>
                    <FormInput
                        required={true}
                        name={'date_of_birth'}
                        detailedLabel={'Date Of birth'}
                        value={data.date_of_birth}
                        type={'date'}
                        onChange={(value) => onChange('date_of_birth', value)}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
                <div className={'col-12 col-md-6 m-0 p-0 ps-md-2'}>
                    <FormInput
                        required={true}
                        name={'national_insurance_number'}
                        detailedLabel={'National insurance number'}
                        value={data.national_insurance_number}
                        type={'text'}
                        onChange={(value) => onChange('national_insurance_number', value)}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
            </div>
            <FormInput
                required={true}
                name={'occupation'}
                detailedLabel={'Occupation'}
                value={data.occupation}
                type={'text'}
                onChange={(value) => onChange('occupation', value)}
                disabled={disabled}
                error={errors}
            />
        </React.Fragment>
    );
}

export default BasicDetails;
